import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-fileGroupEdit',
    templateUrl: './fileGroupEdit.component.html',
    styleUrls: ['./fileGroupEdit.component.css']
})
export class FileGroupEditComponent implements OnInit{
    fileGroupId:number;
    status:boolean;
    
    constructor(public dialogRef: MatDialogRef<FileGroupEditComponent>,@Inject(MAT_DIALOG_DATA) public data: any){
        this.status=false;
        dialogRef.disableClose = true;
    }
    ngOnInit(): void {
        this.fileGroupId=this.data.fileGroupId;
    }
    onClose(){
        this.status=true;
        this.dialogRef.close(this.status);
    }
}